// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__Wn9Yp","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3VJap","obliqueLine":"membershipbadge_obliqueLine__Q83ss"};